// Habillage de l'éditeur de profil ('ProfileEditor').
//
// Même règles que 'primitivesCss' et 'scoreCss' : couleurs toujours issues de
// '--s-*', géométrie en littéraux. Les champs et les boutons pleins sont les
// briques du socle ('.input-field', '.field-label', '.btn-primary',
// '.checkbox') : cette feuille ne fait que les disposer. Préfixe 'pe-' pour ne
// rien heurter dans les deux apps.
//
// DÉTAIL QUI PIÈGE : la feuille est un littéral de gabarit. Un backtick dans
// un commentaire CSS ferme la chaîne. Citer les sélecteurs entre 'apostrophes'.

export const profileEditorCss = `
.pe { color: var(--s-ink); }
.pe-champ { display: block; }
.pe-champ .field-label { margin-bottom: 5px; }
.pe-area { resize: vertical; line-height: 1.45; }
/* Un champ vide se signale sans alarmer : c'est un trou à combler, pas une faute. */
.pe-vide { border-color: var(--s-warn-soft); background: var(--s-warn-tint); }
.pe-aujourdhui { background: var(--s-surface-2); color: var(--s-ink-3); font-style: italic; }
.pe-case {
  display: flex; align-items: center; gap: 8px;
  margin-top: 6px;
  font-size: var(--s-text-xs); color: var(--s-ink-2);
  cursor: pointer;
}

.pe-grille { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.pe-full { grid-column: 1 / -1; }
@media (max-width: 560px) { .pe-grille { grid-template-columns: 1fr; } }

.pe-pile { display: flex; flex-direction: column; gap: 12px; }
.pe-ligne { display: flex; gap: 8px; align-items: flex-start; }
.pe-ligne.pe-bas { align-items: flex-end; }
.pe-flex { flex: 1; min-width: 0; }
.pe-nowrap { white-space: nowrap; }

.pe-section { margin-bottom: 28px; }
.pe-section-tete {
  display: flex; align-items: center; justify-content: space-between; gap: 12px;
  margin-bottom: 12px; padding-bottom: 8px;
  border-bottom: 1px solid var(--s-line);
}
.pe-section-tete h3 { margin: 0; font-size: var(--s-text-base); font-weight: 700; color: var(--s-ink); }

.pe-carte {
  border: 1px solid var(--s-line);
  border-radius: 10px;
  padding: 14px 16px;
  background: var(--s-surface);
}
.pe-carte-tete { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; }
.pe-carte-titre {
  font-size: var(--s-text-xs); font-weight: 700; color: var(--s-ink-3);
  text-transform: uppercase; letter-spacing: .05em;
}
.pe-actions { display: flex; gap: 2px; }

/* 16px d'icône + 2 x 10 = 36px de zone cliquable. */
.pe-icone {
  display: inline-flex; align-items: center; justify-content: center;
  padding: 10px; border: 0; border-radius: 6px;
  background: transparent; color: var(--s-ink-3);
  cursor: pointer; flex: none;
}
.pe-icone:hover:not(:disabled) { color: var(--s-ink); background: var(--s-surface-2); }
.pe-icone.pe-danger:hover:not(:disabled) { color: var(--s-danger); }
.pe-icone:disabled { opacity: .3; cursor: default; }
.pe-icone:focus-visible, .pe-ajout:focus-visible, .pe-tag-x:focus-visible {
  outline: 2px solid var(--s-accent); outline-offset: 2px;
}

.pe-ajout {
  display: inline-flex; align-items: center; gap: 4px; align-self: flex-start;
  padding: 8px 12px; border: 0; border-radius: 6px;
  background: transparent; color: var(--s-accent);
  font: inherit; font-size: var(--s-text-sm); font-weight: 600;
  cursor: pointer;
}
.pe-ajout.pe-petit { padding: 6px 8px; font-size: var(--s-text-xs); }
.pe-ajout:hover { background: var(--s-accent-tint); }

.pe-tags { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 12px; }
.pe-tag {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 4px 10px; border-radius: 999px;
  background: var(--s-accent-tint); color: var(--s-accent);
  border: 1px solid var(--s-accent-border);
  font-size: var(--s-text-sm);
}
.pe-tag-x {
  display: inline-flex; padding: 4px; margin-right: -4px;
  border: 0; border-radius: 999px; background: transparent; color: inherit; cursor: pointer;
}
.pe-tag-x:hover { color: var(--s-danger); }

.pe-vide-note, .pe-note { font-size: var(--s-text-sm); color: var(--s-ink-3); margin: 0; }
.pe-vide-note { font-style: italic; }
.pe-note { margin-top: 8px; font-size: var(--s-text-xs); }
.pe-lien-refuse { margin-top: 4px; color: var(--s-warn); }

.pe-completude {
  margin-bottom: 28px; padding: 14px 16px;
  border: 1px solid var(--s-line); border-radius: 10px;
  background: var(--s-surface-2);
}
.pe-completude-tete {
  display: flex; justify-content: space-between; margin-bottom: 8px;
  font-size: var(--s-text-sm); font-weight: 600; color: var(--s-ink-2);
}
.pe-ton-good { color: var(--s-good-strong); }
.pe-ton-mid  { color: var(--s-warn); }
.pe-ton-low  { color: var(--s-danger); }
.pe-jauge { height: 8px; border-radius: 999px; background: var(--s-track); overflow: hidden; }
.pe-jauge > div { height: 100%; border-radius: 999px; background: var(--s-accent-fill); transition: width .3s; }
`
